var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberShine4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#number-shine-4_svg__filter0_d_13444_90074)",
    clipRule: "evenodd",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.06 7.012h6.518v12.086h2.201v6.033h-2.2V29h-7.333v-3.87h-7.97v-5.273L14.06 7.012zm1.056 2l-7.84 11.463v2.656h7.97V27h3.332v-3.87h2.201v-2.032h-2.2V9.012h-3.463zm-1.549 4.822h1.765c0 .743-.01 1.476-.046 2.219-.027.73-.04 1.302-.04 1.72v3.325H9.074c1.59-2.365 4.493-7.264 4.493-7.264zm-.32 4.642l-.419.622h.418v-.622z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 7.012h6.518v12.086h2.201v6.033h-2.2V29h-7.333v-3.87h-7.97v-5.273L14.06 7.012zm1.056 2l-7.84 11.463v2.656h7.97V27h3.332v-3.87h2.201v-2.032h-2.2V9.012h-3.463zm-1.549 4.822h1.765c0 .743-.01 1.476-.046 2.219-.027.73-.04 1.302-.04 1.72v3.325H9.074c1.59-2.365 4.493-7.264 4.493-7.264zm-.32 4.642l-.419.622h.418v-.622z",
    stroke: "#02A7DB",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "number-shine-4_svg__filter0_d_13444_90074",
    x: 0.775,
    y: 2.512,
    width: 26.504,
    height: 30.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.654902 0 0 0 0 0.858824 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13444_90074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13444_90074",
    result: "shape"
  })))));
}

export default SvgNumberShine4;